import { isBuild } from '@/const/host';
import { previewFile, PREVIEW_WHITE_LIST, safeOpenUrl } from '@/utils/api';
import { Message } from 'irm-ui';

/**
 * 公告打开链接地址
 * @param comeinLink {String} 公告地址
 */
export const previewAnnounce = ({ comeinLink }) => {
	let url = comeinLink;
	if (url) {
		if (isBuild) {
			// 域名切换
			url = url.replace('comein-files.oss-cn-hangzhou.aliyuncs.com', 'media.comein.cn');
		}
		const createUrl = new URL(url);
		const fileHost = createUrl.hostname;
		if ((!PREVIEW_WHITE_LIST.includes(fileHost) && !/comein\.cn/i.test(url)) || /\.(htm|html)$/i.test(url)) {
			// 避免公告未转存 访问403问题
			let link = document.createElement('a');
			link.href = url;
			link.rel = 'noreferrer';
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			return;
		}
		previewFile(url);
	} else {
		Message.error('该文件地址失效，暂不支持打开');
	}
};

/**
 * 自定义模块，文件或链接
 */
export const previewCustom = info => {
	if (info.type == 2) {
		return safeOpenUrl(info.url);
	}
	previewFile(info.fileUrl);
};

/**
 * 百果园 ESG 定制跳转
 */
const includesValue = {
	'S&P': 'https://www.spglobal.com/esg/scores/results?cid=5305915',
	'Sustainalytics': 'https://www.sustainalytics.com/esg-rating/shenzhen-pagoda-industrial-group-corp-ltd/2004624563',
	'HSI': 'https://www.hsi.com.hk/static/uploads/contents/en/esg_report/02411-HK.pdf'
};
export const previewEsgInBGY = item => {
	const { orgName } = item;
	if (orgName && orgName in includesValue) {
		const link = includesValue[orgName];
		link && window.open(link, '_blank');
	}
};
